import 'moment/locale/cs';

import * as React from 'react';

// import { Route } from 'react-router-dom';
import { AdminLayout, Layout } from 'webpanel-admin';
import { Auth, AuthFormProps, AuthSession } from 'webpanel-auth';

// import { CommentsTable } from './components/comments-table';
// import { NotificationsMenu } from 'webpanel-notifications';
// import { INotificationData } from 'webpanel-notifications/lib/NotificationsMenu';
import { ApolloProvider } from 'react-apollo';
import { ENV } from './env';
import { LocaleProvider } from 'antd';
import { LoginForm } from 'webpanel-antd';
import { Redirect } from 'react-router';
import { client } from './graphql';
// Localization
import cs_CZ from 'antd/lib/locale-provider/cs_CZ';
import { entities } from './model';

export const App = () => {
  return (
    <ApolloProvider client={client}>
      <LocaleProvider locale={cs_CZ}>
        <Auth
          type="oauth"
          oauthTokenURL={ENV.REACT_APP_TOKEN_URL}
          clientId={ENV.REACT_APP_CLIENT_ID}
          clientSecret={ENV.REACT_APP_CLIENT_SECRET}
          scope={ENV.REACT_APP_SCOPE}
          userNameGetter={(session: AuthSession) => {
            const payload = session.getTokenPayload();
            return payload && payload.user && payload.user.username;
          }}
          form={(props: AuthFormProps) => (
            <LoginForm authorizationInfo={props} />
          )}
          content={({ logout }) => {
            const menuItems = [
              // <Layout.MenuItem key="/" title="Dashboard" icon="global" />,
              ...entities
                .filter(e => {
                  return e.enabled;
                })
                .map(e => e.menuItem())
            ];
            const structureItems: any = [
              <Layout.StructureItem
                key="/"
                name="Dashboard"
                content={({ location }) => {
                  return <Redirect to="/news-items/" />;
                }}
              />,
              ...entities.filter(e => e.enabled).map(e => e.structureItem())
            ];

            return (
              <AdminLayout
                logoURL="/logo.png"
                logoCollapsedURL="/logo-small.png"
                // autopermissions={true}
                // entities={() => entities}
                menuItems={menuItems}
                structureItems={structureItems}
                logout={logout}
              />
            );
          }}
        />
      </LocaleProvider>
    </ApolloProvider>
  );
};



// WEBPACK FOOTER //
// ./src/App.tsx